import { Outlet } from "react-router-dom";
import Sidebar from "@/components/Sidebar";
import TopBar from "@/components/Header";

export default function Layout() {
  return (
    <div className="app-root" data-testid="app-shell">
      <TopBar />
      <div className="body-row">
        <Sidebar />
        <div className="main-content">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
